import { formDataRequest, postRequest } from '../libs/AxiosService.util';

export async function serviceCreateHealthTips(params) {
    return await formDataRequest('health/tips/create', params);
}

export async function serviceUpdateHealthTips(params) {
    return await formDataRequest('health/tips/update', params);
}

export async function serviceGetHealthTips(params) {
    return await postRequest("health/tips", params);
}

export async function serviceHealthTipsDetail(params) {
    return await postRequest("health/tips/detail", params);
}
export async function serviceDeleteHealthTips(params) {
    return await postRequest("health/delete", params);
}

export async function serviceHealthTipsIsExist (params) {  
    return await postRequest('health/check', params);
}
